<template>
  <div class="living-options-masterplan">
    <div class="row">
      <div class="col-12 mb-4">
        <div class="living-options">
          <h5>Living Options</h5>
          <button class="btn btn-primary mb-4" @click="addLivingOption()" :disabled="isAddingNewObject('livingOptions')">Add Living Option</button>
          <table>
            <thead>
              <tr>
                <th style="width: 80px;">Status</th>
                <th>Label</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="livingOption in livingOptions"
                :key="livingOption._id"
                :class="{ 'active' : activeLivingOptionId == livingOption._id }"
              >
                <td style="width: 80px;">
                  <toggle-button 
                      v-model="livingOption.isEnabled" 
                      :color="{checked: '#28a745', unchecked: '#b8b8b8'}"
                      :sync="true"
                      :width="50" 
                      :height="30"
                      @change="saveLivingOption(livingOption)"
                    />
                </td>
                <td>
                  <div>
                    
                    {{ livingOption.label }}
                  </div>
                </td>
                <td class="text-right table__button-cell">
                  <button class="btn btn-sm btn-outline-danger ml-1" @click="deleteLivingOption(livingOption._id)">Delete</button>
                  <button class="btn btn-sm btn-outline-secondary ml-1" @click="cloneLivingOption(livingOption._id)">Clone</button>
                  <button class="btn btn-sm btn-primary ml-1" @click="activeLivingOptionId = livingOption._id">Edit</button>
                </td>
              </tr>
            </tbody>
          </table>

          <modal-popup :isVisible="!!activeLivingOption">
            <div v-if="activeLivingOption" class="row modal-row-padding" v-click-outside="closeModal">
              <div class="col-6 mb-4">
                <div class="row">
                  <div class="col-6 mb-4">
                    Label
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      v-model="activeLivingOption.label"
                      placeholder="i.e. Salt Apartments"
                    />
                  </div>
                  <div class="col-6 mb-4">
                    Subsection Type
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      v-model="activeLivingOption.subsectionType"
                      placeholder="i.e. Floor, Release, etc."
                    />
                  </div>
                  <div class="col-12 mb-4">
                    Sidebar Description
                    <ck-editor v-model="activeLivingOption.description" id="livingOptionDescription"></ck-editor>
                  </div>
                  <div class="col-12 mb-4">
                    Living Option Logo
                    <input-asset v-model="activeLivingOption.logo" requirements="Required dimensions: none<br>Supported formats: jpg, png"></input-asset>
                  </div>
                  <div class="col-12 mb-4">
                    Sidebar Minimap Image
                    <input-asset v-model="activeLivingOption.sidebarMinimap" defaultCategory="pageBackground" requirements="Required dimensions: none<br>Supported formats: jpg, png"></input-asset>
                  </div>
                </div>
              </div>

              <div class="col-6 mb-4">
                <div class="row">
                  <div class="col-12 mb-4">
                    Associated Subsections
                    <input-multi-select
                      v-model="activeLivingOption.subsectionIds"
                      :options="subsectionOptions"
                    ></input-multi-select>
                  </div>
                  <div class="col-12 mb-4">
                    Background Images
                    <input-asset v-model="activeLivingOption.images" :multiple="true" defaultCategory="pageBackground" requirements="Required dimensions: 3040x1960px<br>Supported formats: jpg, png"></input-asset>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <button v-if="activeLivingOptionId === activeLivingOption._id" class="btn btn-sm btn-outline-danger" @click="cancelEdit('livingOption')">Cancel</button>
                <button v-if="activeLivingOptionId === activeLivingOption._id" class="btn btn-sm btn-primary ml-1" @click="saveLivingOptions(activeLivingOption)">Save</button>
              </div>
            </div>        
          </modal-popup>

        </div>
      </div>

      <div class="col-12 mb-4">
        <fieldset class="form-group">
          <label>Living Option Placement</label>
          <dot-dropper
            :background-image="liveHereBackground"
            v-model="livingOptions"
            :element-ids="livingOptionIds"
            width="3040"
            height="1960"
            dotSize="60"
          ></dot-dropper>
        </fieldset>
        <fieldset class="form-group">
          <label for="pageHeading">Sidebar Heading</label>
          <input
            type="text"
            class="form-control form-control-lg"
            v-model="liveHereHeading"
            placeholder="Living Options"
          />
        </fieldset>
        <fieldset class="form-group">
          <label>Sidebar Description</label>
          <ck-editor v-model="liveHereDescription" id="liveDescription"></ck-editor>
        </fieldset>
        <fieldset class="form-group">
          <label>Living Sidebar Minimap</label>
          <input-asset v-model="liveHereSidebarMinimap" requirements="Required dimensions: none<br>Supported formats: jpg, png"></input-asset>
        </fieldset>
        <fieldset class="form-group">
          <label>Living Masterplan</label>
          <input-asset v-model="liveHereBackground" defaultCategory="pageBackground" requirements="Required dimensions: 3040x1960px<br>Supported formats: jpg, png"></input-asset>
        </fieldset>
        <button class="btn btn-primary" @click="saveLivingOptions">Save</button>
      </div>
    </div>

  </div>
</template>
<script>
import _ from 'lodash'
import { FETCH_CONFIG_ITEMS, CONFIG_ITEMS_EDIT } from "@/store/actions.type"
import { mapState } from 'vuex'
import CkEditor from '@/components/CKEditor'
import DotDropper from '@/components/DotDropper'
import InputAsset from '@/components/InputAsset'
import InputMultiSelect from '@/components/InputMultiSelect'
import CardTabs from '@/components/Cards/TabsCard'
export default {
  components: { CardTabs, CkEditor, DotDropper, InputAsset, InputMultiSelect },
  data () {
    return {
      configItems: [],
      liveHereSidebarMinimap: null,
      liveHereHeading: null,
      liveHereDescription: null,
      liveHereBackground: null,
      livingOptionsConfigItemsKeys: [
        'liveHereSidebarMinimap',
        'liveHereHeading',
        'liveHereDescription',
        'liveHereBackground'
      ],

      activeLivingOptionId: null,
      activeSubsectionId: null,
      activePropertyId: null,
      activePropertyModelId: null,

      propertyFilterText: '',
      propertyModelFilterText: '',
      subsectionFilterText: ''
    }
  },

  computed: {
    activeLivingOption () {
      return _.find(this.livingOptions, livingOption => {
        return livingOption._id === this.activeLivingOptionId
      })
    },

    livingOptions: {
      get () {
        return this.$store.getters.livingOptions
      },
      set (livingOptions) {
        this.$store.commit('SET_LIVING_OPTIONS', livingOptions)
      }
    },

    livingOptionIds () {
      return this.livingOptions.map(livingOption => {
        return livingOption._id
      })
    },

    subsections: {
      get () {
        return this.$store.getters.subsections
      },
      set (subsections) {
        this.$store.commit('SET_SUBSECTIONS', subsections)
      }
    },

    subsectionOptions () {
      let subsectionOptions = []
      this.subsections.forEach(subsection => {
        subsectionOptions.push({
          label: subsection.label,
          value: subsection._id
        })
      })
      return subsectionOptions
    }
  },

  methods: {
    addLivingOption () {
      const livingOption = {
        _id: 'temp',
        label: '',
        displayName: '',
        description: '',
        logo: null,
        marker: {
          x: 100,
          y: 100
        },
        sidebarMinimap: null,
        subsectionImage: null,
        images: [],
        subsectionTypes: '',
        subsectionIds: [],
      }
      this.$store.commit('ADD_LIVING_OPTION', livingOption)
      this.activeLivingOptionId = livingOption._id
    },

    cancelEdit (model) {
      if (model === 'livingOption') {
        this.$store.dispatch('FETCH_LIVING_OPTIONS')
        this.activeLivingOptionId = null
      }

      if (model === 'subsection') {
        this.$store.dispatch('FETCH_SUBSECTIONS')
        this.activeSubsectionId = null
      }

      if (model === 'property') {
        this.$store.dispatch('FETCH_PROPERTIES')
        this.activePropertyId = null
      }

      if (model === 'propertyModel') {
        this.$store.dispatch('FETCH_PROPERTY_MODELS')
        this.activePropertyModelId = null
      }
    },

    cloneLivingOption (id) {
      const livingOption = _.find(this.livingOptions, livingOption => {
        return livingOption._id === id
      })

      let clonedLivingOption = _.clone(livingOption)

      clonedLivingOption._id = 'temp'
      clonedLivingOption.label += '-COPY'
      clonedLivingOption.isFromCRM = false

      this.$store.commit('ADD_LIVING_OPTION', clonedLivingOption)
      this.activeLivingOptionId = clonedLivingOption._id
    },

    closeModal () {
      this.$store.dispatch('FETCH_LIVING_OPTIONS')
      this.activeLivingOptionId = null
    },

    deleteLivingOption (id) {
      this.$store.dispatch('DELETE_LIVING_OPTION', id)
    },

    saveConfig () {
      this.configItems.forEach(configItem => {
        this.livingOptionsConfigItemsKeys.forEach(key => {
          if (key === configItem.key) {
            configItem.value = this[key]
          }
        })
      })
      this.$store.dispatch(CONFIG_ITEMS_EDIT, this.configItems)
    },

    subsectionsByIds (ids) {
      const subsections =  _.filter(this.subsections, subsection => {
        return ids.includes(subsection._id)
      })
      return subsections
    },

    subsectionMarkersByIds (ids) {
      const subsections =  _.filter(this.subsections, subsection => {
        return ids.includes(subsection._id)
      })
      const markers = subsections.map(subsection => {
        subsection.marker.label = subsection.label
        return subsection.marker
      })
      return markers
    },

    isAddingNewObject (model) {
      return _.map(this[model], object => { return object._id }).includes('temp')
    },

    saveLivingOptions () {
      this.saveConfig()
      this.livingOptions.forEach(livingOption => {
        this.$store.dispatch('SAVE_LIVING_OPTION', livingOption)
      })
    },

    saveLivingOption (livingOption) {
      this.$store.dispatch('SAVE_LIVING_OPTION', livingOption)
      this.activeLivingOptionId = null
      this.subsectionsByIds(livingOption.subsectionIds).forEach(subsection => {
        this.$store.dispatch('SAVE_SUBSECTION', subsection)
      })
    },

    async setData () {
      // Get the config items from the API
      this.configItems = await this.$store.dispatch(FETCH_CONFIG_ITEMS)

      // Reduce to just the live config items
      const liveConfigItems = _.filter(this.configItems, item => {
        return this.livingOptionsConfigItemsKeys.includes(item.key)
      })

      // Map the live items to the component data
      liveConfigItems.forEach(item => {
        this[item.key] = item.value
      })
    }
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
    this.$store.dispatch('FETCH_LIVING_OPTIONS')
    this.$store.dispatch('FETCH_SUBSECTIONS')
    this.setData()
  }
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";

  select {
    width: 100%;
  }

  .card {
    z-index: unset !important;
  }

  .living-option, .subsection, .property, .property-model {
    border-radius: 4px;
    padding: 7px;
    border: 1px solid #d4d4d4;
    margin: 1em 0;
  }

  .selection-list {
    border-radius: 4px;
    padding: 7px;
    border: 1px solid #d4d4d4;   
    max-height: 200px;
    overflow: scroll; 
  }

  .list-wrapper {
    max-height: 600px;
    overflow: scroll;
  }

  .living-options {
    table {
      border-collapse: separate;
      border-spacing: 0;
      border: 1px solid #d4d4d4;
      border-radius: 6px;
      // overflow: hidden;
      width: 100%;
    }

    .table__button-cell {
      // width: 120px;

      button {
        opacity: 0;
      }
    }

    tbody {
      display: block;
      max-height: none;
      overflow: auto;

      @include v-breakpoint(800px) {
        max-height: calc(100vh - 500px);
      }

      tr:hover {
        &:not(.active) {
          background-color: #f5f5f5;
        }

        .table__button-cell button {
          opacity: 1;
        }
      }
    }

    thead, tbody tr {
      display: table;
      width: 100%;
      table-layout: fixed;
    }

    thead {
      background-color: #f0f0f0;
      border-bottom: 1px solid #d4d4d4;
      font-size: 12px;
      position: sticky;
      text-transform: uppercase;
      top: 0;
      z-index: 10;
    }

    th, td {
      font-weight: 400;
      padding: 10px 15px;
    }

    tr {
      &:nth-child(2n) {
        background-color: #fafafa;
      }
    }
  }

  .modal-row-padding {
    padding: 30px 0;
  }
</style>